import moment from 'moment';

type _Date = string | Date;
type Options = {
  unitOfTime?: moment.unitOfTime.Diff;
  startOf?: moment.unitOfTime.StartOf;
  pattern?: string;
};

/**
 * Calcula a diferença em dias entre a data fornecida e a data atual.
 *
 * @param date - A data alvo para calcular a diferença.
 * @param options - Opções para configurar a unidade de tempo e o início do dia.
 * @returns Um objeto contendo:
 *   - `value`: A diferença em dias entre a data fornecida e a data atual.
 *   - `isLate`: Indica se a data fornecida é anterior à data atual.
 *   - `isYesterday`: Indica se a data fornecida é o dia anterior à data atual.
 *   - `isToday`: Indica se a data fornecida é o mesmo dia da data atual.
 *   - `isTomorrow`: Indica se a data fornecida é o dia seguinte à data atual.
 */
export const getDiffDaysFromToday = (date?: _Date, options: Options = {}) => {
  if (!date) {
    return { value: 0, isLate: false, isYesterday: false, isToday: true, isTomorrow: false };
  }

  options.unitOfTime = 'days';
  options.startOf = 'day';
  options.pattern = 'YYYY-MM-DD';

  const today = moment(new Date(), options.pattern).startOf(options.startOf);
  const targetDate = moment(date, options.pattern).startOf(options.startOf);
  const differenceInDays = targetDate.diff(today, options.unitOfTime);

  return {
    value: differenceInDays,
    isLate: differenceInDays < 0,
    isYesterday: differenceInDays === -1,
    isToday: differenceInDays === 0,
    isTomorrow: differenceInDays === 1,
  };
};
